import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var BusSVG = function BusSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M13,17.5A1.5,1.5,0,0,1,11.5,19H10.13V16H11.5A1.5,1.5,0,0,1,13,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M12.63,22.53a3.863,3.863,0,0,0-.21.6H10.13V22H11.5A1.486,1.486,0,0,1,12.63,22.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M27.2,7.13v2.6H10.13V7.17a.043.043,0,0,1,.04-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__secondary-color-fill",
    x: "10.13",
    y: "9.73",
    width: "17.07",
    height: "3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M37.87,23.13H35.58a4.246,4.246,0,0,0-8.23,0h-6.7a4.24,4.24,0,0,0-8.02-.6A1.486,1.486,0,0,0,11.5,22H10.13V19H11.5a1.5,1.5,0,0,0,0-3H10.13v-.33H37.87S37.88,23.13,37.87,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M40,23.13v4.74A2.138,2.138,0,0,1,37.87,30H10.13A2.138,2.138,0,0,1,8,27.87V26.5a1.51,1.51,0,0,1,1.19-1.47,1.988,1.988,0,0,0,.94.24h2.29a4.246,4.246,0,0,0,8.23,0h6.7a4.246,4.246,0,0,0,8.23,0h2.29A2.14,2.14,0,0,0,40,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M8,13v3H3.5a1.5,1.5,0,0,1,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M8,19v3H5.5a1.5,1.5,0,0,1,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M37.716,32h-5a1.5,1.5,0,0,0,0,3h5a1.5,1.5,0,1,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M26.5,37h-12a1.5,1.5,0,0,0,0,3h12a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M37.87,5H10.13A2.138,2.138,0,0,0,8,7.13v16a2.123,2.123,0,0,0,1.19,1.9,1.988,1.988,0,0,0,.94.24h2.29a4.246,4.246,0,0,0,8.23,0h6.7a4.246,4.246,0,0,0,8.23,0h2.29A2.14,2.14,0,0,0,40,23.13v-16A2.138,2.138,0,0,0,37.87,5ZM29.33,7.13h8.5a.043.043,0,0,1,.04.04v6.36H29.33Zm-19.2.04a.043.043,0,0,1,.04-.04H27.2v6.4H10.13Zm6.4,19.16a2.13,2.13,0,1,1,2.14-2.13A2.132,2.132,0,0,1,16.53,26.33Zm14.94,0A2.13,2.13,0,1,1,33.6,24.2,2.134,2.134,0,0,1,31.47,26.33Zm6.4-3.2H35.58a4.246,4.246,0,0,0-8.23,0h-6.7a4.24,4.24,0,0,0-8.02-.6,3.863,3.863,0,0,0-.21.6H10.13V15.67H37.87S37.88,23.13,37.87,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M37.87,7.17v6.36H29.33V7.13h8.5A.043.043,0,0,1,37.87,7.17Z"
  }));
};
BusSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
BusSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Bus")
};
export default withDetailedIcon(BusSVG);